<template>
  <div>
    <v-row>
      <v-col cols="2" class="pa-0">
        <v-row>{{ defaultPrice }}</v-row>
        <v-row>
          <div v-if="showKind" class="overline">* {{ product.meta.rate_kind }}</div>
        </v-row>
        <v-row justify="start" align="center" v-if="usingOldDate">
          <v-icon small left color="warning">warning</v-icon>
          <span class="caption warning--text">Rate from: {{ product.rate_year }}</span>
        </v-row>
      </v-col>
      <v-col cols="10" class="pa-0">
        <v-row align="center">
          <v-btn :color="isDefaultPrice ? '' : 'green'" depressed small @click="setCustomPrice()">
            <v-icon small left>swap_horiz</v-icon>
            <span class="caption">Custom</span>
          </v-btn>
          <v-btn :color="isDefaultPrice ? 'green' : ''" depressed small @click="setDefaultPrice()">
            <v-icon color="white" small left>check_circle</v-icon>
            <span class="caption">Default</span>
          </v-btn>
          <div class="ml-2" style="width: 150px">
            <v-autocomplete
              dense
              outlined
              hide-details
              item-text="label"
              item-value="value"
              :items="source"
              :disabled="isDefaultPrice"
              :value="rateType"
              @input="updateRateType"
            />
          </div>
        </v-row>
        <v-row v-for="(price, index) in prices" :key="index" class="align-center mt-2">
          <v-col cols="1" class="pa-0">
            <div>Rate</div>
          </v-col>
          <v-col cols="4" class="d-flex align-center pt-0 pb-0">
            <e-number
              :env="env"
              :disabled="isDefaultPrice"
              :value="price.price.price"
              :type="price.price.price.type"
              @input="(v) => updateRate(index, v)"
            />
            <span class="ml-2">/</span>
            <v-autocomplete
              class="ml-2"
              :class="{ 'duplicate-room-type': isDuplicateRoomType(index) }"
              dense
              outlined
              :hide-details="isDuplicateRoomType(index) ? false : true"
              item-text="label"
              item-value="value"
              :items="getSeasonPerRoomTypeSource(index)"
              :value="price.roomType"
              :disabled="isRoomTypeSelectedDisabled()"
              :error="isDuplicateRoomType(index)"
              :error-messages="isDuplicateRoomType(index) ? 'Duplicate room type' : []"
              @input="(v) => updateRoomType(index, v)"
            />
          </v-col>
          <v-col cols="2.5">
            <div v-if="!isDefaultPrice">
              <g-button
                v-if="index == 0"
                label="Generate Prices"
                icon="add"
                @onclick="generatePrices"
                :disabled="!canGeneratePrices()"
              />
              <v-btn v-else small icon @click="removeRate(index)">
                <v-icon small>clear</v-icon>
              </v-btn>
            </div>
          </v-col>
          <v-col cols="2" class="pa-0">
            <v-row v-if="taxShow" class="pa-0" justify="space-between">
              <span class="subtitle-2">+ Tax</span>
              <span>{{ taxShow }} %</span>
            </v-row>
            <v-row v-if="taxInclusiveShow" class="pa-0" justify="space-between">
              <span class="subtitle-2">* Tax Inclusive</span>
            </v-row>
            <v-row v-if="customTaxShow" class="pa-0" justify="space-between">
              <span class="subtitle-2">+ Custom Tax</span>
              <span>{{ customTaxShow }} %</span>
            </v-row>
            <v-row v-if="occupancyShow" class="pa-0" justify="space-between">
              <span class="subtitle-2">+ Occupancy</span>
              <TotalWrapper
                :showConvert="showConverstion"
                :formatedTotal="occupancyShow.print"
                :convertedTotal="occupancyShow.convert"
              />
            </v-row>
            <v-row v-if="customOccupancyShow" class="pa-0" justify="space-between">
              <span class="subtitle-2">+ Custom Occupancy</span>
              <TotalWrapper
                :showConvert="showConverstion"
                :formatedTotal="customOccupancyShow.print"
                :convertedTotal="customOccupancyShow.convert"
              />
            </v-row>
            <v-row v-if="resortFeeShow" class="pa-0" justify="space-between">
              <span class="subtitle-2">+ Resort Fee</span>
              <TotalWrapper
                :showConvert="showConverstion"
                :formatedTotal="resortFeeShow.print"
                :convertedTotal="resortFeeShow.convert"
              />
            </v-row>
            <v-row>
              <v-col class="pa-0">
                <v-row justify="space-between" v-for="(extra, index) in extraList" :key="index" class="pa-0">
                  <span class="subtitle-2">+ {{ extraRef[extra.key].label }}</span>
                  <span v-if="extra.astype === 'COST'">{{ extra.value.cur }} {{ extra.value.value }}</span>
                  <span v-if="extra.astype === 'PERCENT'">{{ extra.value }} %</span>
                </v-row>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="2.5" class="subtitle-2">
            <TotalWrapper
              class="ring grey lighten-3 px-2 py-1"
              :showConvert="showConverstion"
              :formatedTotal="price.price.totalPrice_print"
              :convertedTotal="price.price.totalConvert_print"
            />
          </v-col>
        </v-row>
        <v-row v-if="!isRoomTypeSelectedDisabled()" class="align-center mb-2">
          <g-button label="Add Rate" icon="add" :disabled="!canAddRate()" @onclick="addRate" />
        </v-row>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { ProductFields } from "@/config/fields/products";
import { SeasonProductPerRoomTypes } from "@/config/fields/products";
import { ProductPerRoomTypes } from "@/config/fields/products";
import { ProductService } from "@/modules/products";
import EXTRA_OPTIONS from "@/config/products/EXTRA_OPTIONS";
import moneyService from "@/services/money";
import TotalWrapper from "./pricerow/_TotalWrapper";
import ENumber from "../../../../../../../components/form/special/ENumber";
import utils from "@/modules/products/components/utils";

export default {
  components: {
    ENumber,
    TotalWrapper,
  },
  props: {
    type: String,
    country: String,
    product: Object,
    price: [Object, Array],
    supplierMeta: Object,
    showKind: Boolean,
    customPrices: Object,
    customPricesV2: Object,
    bookingDayYear: String,
    bookingSupplierMeta: Object,
  },
  data() {
    return {
      prices: [],
      isDefaultPrice: true,
      rateType: null,
      extraRef: EXTRA_OPTIONS,
    };
  },
  watch: {
    price: {
      handler(newValue) {
        if (!newValue) return;

        this.prices = [];

        const productId = this.product.id;
        const prices = this.price;
        const customPrices = this.customPrices[productId];
        const customPricesV2 = this.customPricesV2[productId] || [];

        if (this.product.seasonal) {
          if (customPrices != null && Object.values(customPrices)[0] != null) {
            // {"custom_prices":{"aaaa":{"1":{"type":"PROOM","value":"$300.00","cur":"USD"},"2":{"type":"PROOM","value":"$400.00","cur":"USD"}}}}
            this.rateType = Object.values(customPrices)[0].type;
            this.isDefaultPrice = false;

            for (let i = 0; i < prices.length; i++) {
              const price = prices[i];
              const customPrice = customPrices[i];
              const convertedPrice = customPrice ? this.getConvertedPrice(customPrice) : price;
              this.prices.push({ price: convertedPrice, roomType: price.roomType });
            }
          } else if (customPricesV2.length > 0) {
            // {"custom_prices_v2":{"aaaa":[{"price":{"defaultType":"PROOM","price":{"type":"PROOM","value":"$100.00","cur":"USD"},"price_print":"$ 100.00 / Per Room","priceConvert":0,"priceConvert_print":"($0 USD)","totalPrice":{"tax":0,"cur":"USD","value":"100.00","raw_value":100,"type":"PROOM"},"totalPrice_print":"$ 100.00 / Per Room","totalConvert":0,"totalConvert_print":"($0 USD)","roomType":"DEFAULT","dateStart":"Jul/1","dateEnd":"Dec/31"},"roomType":"DEFAULT"},{"price":{"defaultType":"PROOM","price":{"type":"PROOM","value":"$120.00","cur":"USD"},"price_print":"$ 120.00 / Per Room","priceConvert":0,"priceConvert_print":"($0 USD)","totalPrice":{"tax":0,"cur":"USD","value":"120.00","raw_value":120,"type":"PROOM"},"totalPrice_print":"$ 120.00 / Per Room","totalConvert":0,"totalConvert_print":"($0 USD)","roomType":"DOUBLE_DOUBLE","dateStart":"Jul/1","dateEnd":"Dec/31"},"roomType":"DOUBLE_DOUBLE"}]}}
            this.rateType = customPricesV2[0].price.type;
            this.isDefaultPrice = false;

            for (let i = 0; i < customPricesV2.length; i++) {
              const customPrice = customPricesV2[i];
              const convertedPrice = this.getConvertedPrice(customPrice.price);
              this.prices.push({ price: convertedPrice, roomType: customPrice.roomType });
            }
            this.warnIfDuplicateRoomTypes();
          } else if (prices.length > 0) {
            // {"custom_prices_v2":{"aaaa":[{"price":{"type":"PROOM","value":"$100.00","cur":"USD"},"roomType":"DEFAULT"},{"price":{"type":"PROOM","value":"$300.00","cur":"USD"},"roomType":"DOUBLE_DOUBLE"}]}}
            this.rateType = prices[0].price.type;
            this.isDefaultPrice = true;

            for (let i = 0; i < prices.length; i++) {
              const price = prices[i];
              this.prices.push({ price: price, roomType: price.roomType });
            }
          } else {
            // No data in this period
          }
        } else {
          if (customPrices != null) {
            // {"custom_prices":{"type":"PROOM","value":"$30.00","cur":"USD"}}
            this.rateType = customPrices.type;
            this.isDefaultPrice = false;
            const convertedPrice = this.getConvertedPrice(customPrices);
            this.prices.push({
              price: convertedPrice,
              roomType: customPrices.type === "PROOM" ? "DOUBLE_QK" : "DEFAULT",
            });
          } else if (customPricesV2.length > 0) {
            // {"custom_prices_v2":{"aaaa":[{"price":{"type":"PROOM","value":"$30.00","cur":"USD"},"roomType":"DEFAULT"},{"price":{"type":"PROOM","value":"$30.00","cur":"USD"},"roomType":"SINGLE_DOUBLE"}]}}
            this.rateType = customPricesV2[0].price.type;
            this.isDefaultPrice = false;

            for (let i = 0; i < customPricesV2.length; i++) {
              const customPrice = customPricesV2[i];
              const convertedPrice = this.getConvertedPrice(customPrice.price);
              this.prices.push({ price: convertedPrice, roomType: customPrice.roomType });
            }
            this.warnIfDuplicateRoomTypes();
          } else {
            // {"defaultType":"PROOM","price":{"type":"PROOM","value":"$105.00","cur":"USD"},"price_print":"$ 105.00 / Per Room","priceConvert":0,"priceConvert_print":"($0 USD)","totalPrice":{"tax":0,"cur":"USD","value":"105.00","raw_value":105,"type":"PROOM"},"totalPrice_print":"$ 105.00 / Per Room","totalConvert":0,"totalConvert_print":"($0 USD)"}
            this.rateType = prices.price.type;
            this.isDefaultPrice = true;
            this.prices.push({ price: prices, roomType: prices.price.type === "PROOM" ? "DOUBLE_QK" : "DEFAULT" });

            const perRooms = this.product.meta.per_room ?? [];
            for (let i = 0; i < perRooms.length; i++) {
              const perRoom = perRooms[i];

              let roomType;
              if (JSON.stringify(perRoom.type) === JSON.stringify(ProductPerRoomTypes.SINGLE.value)) {
                roomType = "SINGLE_DK";
              } else if (JSON.stringify(perRoom.type) === JSON.stringify(ProductPerRoomTypes.TWIN.value)) {
                roomType = "DOUBLE_DOUBLE";
              } else if (JSON.stringify(perRoom.type) === JSON.stringify(ProductPerRoomTypes.TRIPLE.value)) {
                roomType = "TRIPLE";
              } else {
                roomType = "QUAD";
              }

              const convertedPrice = this.getConvertedPrice({
                type: this.rateType,
                value: perRoom.value,
                cur: perRoom.cur,
              });
              this.prices.push({ price: convertedPrice, roomType: roomType });
            }
          }
        }
      },
      deep: true,
      immediate: true,
    },
    hasDuplicateRoomTypes: {
      immediate: true,
      handler(invalid) {
        this.$emit("custom-price-validity", !invalid);
      },
    },
  },
  computed: {
    source() {
      return ProductFields.rate_type.getSource(this.product.product_type, this.type);
    },
    defaultPrice() {
      if (this.product.seasonal) {
        const rate = this.product.seasonal ? this.product.rate[0].rate : this.product.rate;
        const defaultRoomType = rate.type === "PROOM" ? "DOUBLE_QK" : "DEFAULT";
        const emptyPrice = this.price.find((price) => price.roomType === "");
        const defaultPrice = this.price.find((price) => price.roomType === defaultRoomType);
        if (defaultPrice != null) return defaultPrice.price_print;
        if (emptyPrice != null) return emptyPrice.price_print;
        return "";
      } else {
        return this.price.price_print;
      }
    },
    usingOldDate() {
      return `${this.product.rate_year}` !== this.bookingDayYear;
    },
    env() {
      return this.$store.getters["AccountStore/environment"];
    },
    showConverstion() {
      return this.$store.getters["AccountStore/environment"] !== "USA";
    },
    taxShow() {
      if (this.taxInclusiveShow || this.customTaxShow) return;
      return this.bookingSupplierMeta.supplier_meta?.tax;
    },
    taxInclusiveShow() {
      return this.product.tax_inclusive;
    },
    customTaxShow() {
      if (this.taxInclusiveShow) return null;
      if (this.product.meta && this.product.meta.custom_tax) return this.product.meta.custom_tax;
      return null;
    },
    occupancyShow() {
      if (!this.supplierMeta) return null;
      if (this.product.meta && this.product.meta.custom_occupancy) return null;
      if (this.product.product_type !== "ROOM") return null;

      const occupancy = this.bookingSupplierMeta.supplier_meta?.occupancy;
      if (!occupancy || Number(occupancy.value) === 0) return null;
      if (occupancy) {
        let print = `${occupancy.cur === "USD" ? "" : occupancy.cur}${occupancy.value}`;
        let convert = moneyService.getConvertedValue(occupancy.value, this.country, this.$store.getters);
        return {
          print: print,
          convert: ProductService.formatConvert(convert),
        };
      }
      return null;
    },
    customOccupancyShow() {
      if (this.$store.getters["AccountStore/environment"] !== "JPN") return null;
      if (this.product.product_type !== "ROOM") return null;

      const occupancy = this.product.meta && this.product.meta.custom_occupancy;
      if (occupancy) {
        let print = `${occupancy.cur}${occupancy.value}`;
        let convert = moneyService.getConvertedValue(occupancy.value, this.country, this.$store.getters);
        return {
          print: print,
          convert: ProductService.formatConvert(convert),
        };
      }
      return null;
    },
    resortFeeShow() {
      if (this.product.product_type !== "ROOM") return null;

      let resort_fee = null;
      if (this.bookingSupplierMeta.has_custom_resortfee) {
        resort_fee = this.bookingSupplierMeta.custom_resortfee_value;
      } else if (!this.supplierMeta || this.extraList.find((i) => i.key === "extra_resort_fee")) {
        return null;
      } else {
        resort_fee = this.bookingSupplierMeta.supplier_meta?.resort_fee;
      }

      if (resort_fee && Number(resort_fee.value) === 0) {
        return null;
      } else if (resort_fee) {
        let print = `${resort_fee.value}`;
        let convert = moneyService.getConvertedValue(resort_fee.value, this.country, this.$store.getters);
        return {
          print: print,
          convert: ProductService.formatConvert(convert),
        };
      }
      return null;
    },
    extraList() {
      const meta = this.product.meta;
      if (!meta) return [];

      return Object.keys(meta)
        .filter((v) => v.includes("extra_"))
        .map((key) => {
          return {
            key,
            ...meta[key],
          };
        });
    },
    getCurrency() {
      return moneyService.getCurrencySource(this.env).currency;
    },
    duplicateRoomTypes() {
      return utils.findDuplicateRoomTypes(this.prices.map((p) => p.roomType));
    },
    hasDuplicateRoomTypes() {
      return !this.isDefaultPrice && this.duplicateRoomTypes.length > 0;
    },
  },
  methods: {
    isDuplicateRoomType(index) {
      if (this.isDefaultPrice) return false;
      const roomType = this.prices[index] && this.prices[index].roomType;
      return !!roomType && this.duplicateRoomTypes.includes(roomType);
    },
    setDefaultPrice() {
      this.isDefaultPrice = true;
      this.prices = [];

      if (this.product.seasonal) {
        this.rateType = this.price[0].price.type;

        for (let i = 0; i < this.price.length; i++) {
          const price = this.price[i];
          this.prices.push({ price: price, roomType: price.roomType });
        }
      } else {
        this.rateType = this.price.price.type;
        this.prices.push({ price: this.price, roomType: this.price.price.type === "PROOM" ? "DOUBLE_QK" : "DEFAULT" });

        const perRooms = this.product.meta.per_room ?? [];
        for (let i = 0; i < perRooms.length; i++) {
          const perRoom = perRooms[i];
          let roomType;

          if (JSON.stringify(perRoom.type) === JSON.stringify(ProductPerRoomTypes.SINGLE.value)) {
            roomType = "SINGLE_DK";
          } else if (JSON.stringify(perRoom.type) === JSON.stringify(ProductPerRoomTypes.TWIN.value)) {
            roomType = "DOUBLE_DOUBLE";
          } else if (JSON.stringify(perRoom.type) === JSON.stringify(ProductPerRoomTypes.TRIPLE.value)) {
            roomType = "TRIPLE";
          } else {
            roomType = "QUAD";
          }

          const convertedPrice = this.getConvertedPrice({
            type: this.rateType,
            value: perRoom.value,
            cur: perRoom.cur,
          });
          this.prices.push({ price: convertedPrice, roomType: roomType });
        }
      }
      this.emitCustomPrice();
    },
    setCustomPrice() {
      this.isDefaultPrice = false;
      this.emitCustomPrice();
    },
    updateRateType(v) {
      if (v !== "PROOM") {
        this.prices = this.prices.slice(0, 1);
      }

      const [firstPrice] = this.prices;
      firstPrice.price = this.getConvertedPrice({
        type: v,
        value: firstPrice.price.price.value,
        cur: firstPrice.price.price.cur,
      });
      firstPrice.roomType = v === "PROOM" ? "DOUBLE_QK" : "DEFAULT";

      this.rateType = v;
      this.emitCustomPrice();
    },
    updateRate(index, v) {
      this.prices[index].price = this.getConvertedPrice(v);
      this.emitCustomPrice();
    },
    updateRoomType(index, v) {
      const usedByOthers = this.prices.map((p, i) => (i === index ? null : p.roomType));
      if (v && usedByOthers.includes(v)) {
        this.$root.$error(
          `Room type "${this.roomTypeLabel(v)}" is already used. Each room type can only appear once.`
        );
        return;
      }
      this.prices[index].roomType = v;
      this.emitCustomPrice();
    },
    addRate() {
      const nextType = utils.getNextUnusedRoomType(this.prices.map((p) => p.roomType));
      if (!nextType) return;
      this.prices.push({
        price: this.getConvertedPrice({ type: this.rateType, value: "0", cur: this.getCurrency }),
        roomType: nextType,
      });
      this.emitCustomPrice();
    },
    removeRate(index) {
      this.prices = this.prices.filter((_, i) => i !== index);
      this.emitCustomPrice();
    },
    generatePrices() {
      const doublePrice = this.prices.find((price) => price.roomType == "DOUBLE_QK");
      const emptyPrice = this.prices.find((price) => price.roomType == "");

      const basePrice = doublePrice
        ? moneyService.stripFormatting(doublePrice.price.price.value)
        : emptyPrice
          ? moneyService.stripFormatting(emptyPrice.price.price.value)
          : 0;

      const used = new Set(this.prices.map((p) => p.roomType).filter(Boolean));
      ["SINGLE_DK", "DOUBLE_DOUBLE", "TRIPLE", "QUAD"].forEach((type) => {
        if (used.has(type)) return;
        const basePriceWithAdditionalPrice = basePrice + this.getAdditionalPrice(this.env, type);
        this.prices.push({
          price: this.getConvertedPrice({
            type: this.rateType,
            value: basePriceWithAdditionalPrice,
            cur: this.getCurrency,
          }),
          roomType: type,
        });
      });

      this.emitCustomPrice();
    },
    getAdditionalPrice(environment, roomType) {
      const priceModifiers = {
        USA: { SINGLE_DK: 0, TRIPLE: 20, DOUBLE_DOUBLE: 20, QUAD: 40 },
        CDA: { SINGLE_DK: 0, TRIPLE: 20, QUAD: 40 },
      };
      return priceModifiers[environment]?.[roomType] || 0;
    },
    getConvertedPrice(value) {
      return ProductService.packagePrice(
        { ...this.product },
        value,
        this.supplierMeta,
        this.country,
        false,
        this.$store.getters,
        true,
        this.bookingSupplierMeta
      );
    },
    isRoomTypeSelectedDisabled() {
      return this.isDefaultPrice || this.rateType !== "PROOM";
    },
    canGeneratePrices() {
      return this.rateType === "PROOM" && this.prices.length == 1 && this.prices[0].roomType === "DOUBLE_QK";
    },
    canAddRate() {
      return !!utils.getNextUnusedRoomType(this.prices.map((p) => p.roomType));
    },
    getSeasonPerRoomTypeSource(index) {
      const isPerRoom = this.rateType === "PROOM";
      const base = SeasonProductPerRoomTypes.filter((roomType) =>
        isPerRoom ? roomType.value !== "DEFAULT" : roomType.value === "DEFAULT"
      );
      if (!isPerRoom) return base;

      const usedByOthers = this.prices.map((p, i) => (i === index ? null : p.roomType));
      const currentValue = this.prices[index] && this.prices[index].roomType;
      return utils.filterAvailableRoomTypeOptions(base, usedByOthers, currentValue);
    },
    roomTypeLabel(value) {
      const match = SeasonProductPerRoomTypes.find((t) => t.value === value);
      return match ? match.label : value;
    },
    warnIfDuplicateRoomTypes() {
      const dupes = utils.findDuplicateRoomTypes(this.prices.map((p) => p.roomType));
      if (!dupes.length) return;
      this.$root.$error(
        `Duplicate room type(s) in custom prices: ${dupes.map((t) => this.roomTypeLabel(t)).join(", ")}. Please fix before saving.`
      );
    },
    emitCustomPrice() {
      if (this.isDefaultPrice) {
        this.$emit("custom-price-validity", true);
        this.$emit("custom-prices-updated", null);
        return;
      }
      const dupes = utils.findDuplicateRoomTypes(this.prices.map((p) => p.roomType));
      const isValid = dupes.length === 0;
      this.$emit("custom-price-validity", isValid);
      if (!isValid) return;
      const customPrices = [];
      for (let i = 0; i < this.prices.length; i++) {
        customPrices.push({ price: this.prices[i].price.price, roomType: this.prices[i].roomType });
      }

      this.$emit("custom-prices-updated", customPrices);
    },
  },
  mounted() {},
};
</script>

<style scoped>
.duplicate-room-type >>> .v-input__slot {
  border-color: #d32f2f !important;
}
.duplicate-room-type >>> fieldset {
  border-color: #d32f2f !important;
}
</style>
